import { createApp } from 'vue'
import { createPinia } from 'pinia'
import axios from 'axios'
import App from './App.vue'
import './style.css'

// Configure axios
axios.defaults.baseURL = import.meta.env.VITE_API_URL || 'http://localhost:3000'
axios.defaults.timeout = 10000

// Add request interceptor for logging
axios.interceptors.request.use(
  (config) => {
    console.log(`🌐 API Request: ${config.method?.toUpperCase()} ${config.url}`)
    return config
  },
  (error) => {
    console.error('🚨 API Request Error:', error)
    return Promise.reject(error)
  }
)

// Add response interceptor for error handling
axios.interceptors.response.use(
  (response) => {
    console.log(`✅ API Response: ${response.status} ${response.config.url}`)
    return response
  },
  (error) => {
    console.error('🚨 API Response Error:', error.response?.status, error.response?.data)
    return Promise.reject(error)
  }
)

// Create Vue app
const app = createApp(App)

// Install Pinia
const pinia = createPinia()
app.use(pinia)

// Global properties
app.config.globalProperties.$axios = axios

// Error handler
app.config.errorHandler = (err, instance, info) => {
  console.error('🚨 Vue Error:', err)
  console.error('🚨 Vue Error Info:', info)
}

// Mount app
app.mount('#app')

console.log('🚀 IoT Device Management Frontend initialized')
console.log('🌐 API Base URL:', axios.defaults.baseURL)